import React, { useEffect, useState } from 'react';
import { isNullOrUndefined, getNewId } from 'utils/Global';
import './ImagingSchedule.scss';
import { ReactComponent as AddIcon } from 'Icons/ExperimentTab/Add.svg';
import { ReactComponent as RemoveIcon } from 'Icons/ExperimentTab/Remove.svg';
import Table from './Table';
import TextInput from './TextInput';
import CheckBox from './CheckBox';
import { setImagingScheduleDetails, setIsDirty, getIsDirty } from './ImagingScheduleData';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';
import { useRMSelector } from 'redux/hooks';
import { selectExpSaved } from 'redux/selectors/StateSelectors';
import { upsertImagingSchedule } from '../../../../redux/reducers/experimentDataReducer';
import { useDispatch } from 'react-redux';
import { cloneDeep } from 'lodash';
import { useAwaitableModal } from 'CustomHooks/useAwaitableModal';
import { IStyle } from 'Styles/styleModel';
import { fetchImagingSchedulesAsync } from 'redux/thunks/experiment';
import useRMLite from 'CustomHooks/useRMLite';
import ImagingScheduleService from 'business/services/ImagingScheduleService';
import ExperimentService from 'business/services/ExperimentService';

let schedules = [];
let imagingScheduleOptions = [];
let headersContent = [];
let selectedScheduleId = 0;
let selectedRow: { dayNum: any; hourNum: any; entryId: number } = {
  dayNum: '',
  hourNum: '',
  entryId: -1,
};
export default function ImagingSchedule(props) {
  const [selectedValueOptions, setSelectedValueOptions] = useState(null);
  const [columns, setColumns] = useState(null);
  const [data, setData] = useState(null);
  const [schedulingOptionsHtml, setSchedulingOptionsHtml] = useState(null);
  const rmLite = useRMLite();

  const _selectExpSaved = useRMSelector(selectExpSaved);

  const dispatch = useDispatch();
  const exp = useRMSelector((state) => state.experiment.expData);
  const { showModal, modalContent: awaitableModalContent } = useAwaitableModal();
  const awaitableModalInfo = {
    body: 'Are you sure you want to customize the imaging schedule?',
    heading: 'Customize Schedule',
  };
  const { expId, bulkMode = false, experimentIds = [] } = props;
  const imagingScheduleService = new ImagingScheduleService();
  const experimentService = new ExperimentService();
  function columnsHtml(names) {
    const cols = [];
    let isAllSelected = true;
    let isEntryExistAgainstSchedule = false;
    for (let i = 0; i < imagingScheduleOptions.length; i++) {
      for (let j = 0; j < headersContent.length; j++) {
        if (imagingScheduleOptions[i].id === selectedScheduleId) {
          const isFind = isFindInEnteries(imagingScheduleOptions[i], headersContent[j]);
          if (!isFind || !imagingScheduleOptions[i].isSelected) {
            isAllSelected = false;
            break;
          }
          isEntryExistAgainstSchedule = true;
        }
      }
      if (!isAllSelected) {
        break;
      }
    }
    if (!isEntryExistAgainstSchedule) {
      isAllSelected = false;
    }
    cols.push(
      {
        Header: (
          <div id="imagingschedule-col-maincheck" data-align="center">
            <div className="height35" />
          </div>
        ),
        accessor: 'maincheck',
      },
      {
        id: 'imagingschedule-col-day',
        Header: 'Day',
        accessor: 'day',
      },
      {
        id: 'imagingschedule-col-hour',
        Header: 'Hour',
        accessor: 'hour',
      },
    );
    for (let i = 0; i < names.length; i++) {
      const name = names[i];
      let acc = '';
      name.split(' ').map((n) => (acc += n));
      let isColSelected = true;
      isEntryExistAgainstSchedule = false;
      for (let i = 0; i < imagingScheduleOptions.length; i++) {
        if (imagingScheduleOptions[i].id === selectedScheduleId) {
          const isFind = isFindInEnteries(imagingScheduleOptions[i], name);
          if (
            !isFind ||
            (!imagingScheduleOptions[i].isSelected &&
              imagingScheduleOptions[i].cpName === name)
          ) {
            isColSelected = false;
            break;
          }
          isEntryExistAgainstSchedule = true;
        }
        if (!isColSelected) {
          break;
        }
      }
      if (!isEntryExistAgainstSchedule) {
        isColSelected = false;
      }
      cols.push({
        Header: (
          <div id={`imagingschedule-col-${acc.toLowerCase()}`} data-align="center">
            <div className="height35">{name}</div>
            <div
              id={`imagingschedule-col-checkbox-${acc.toLowerCase()}`}
              style={{ display: 'inline' }}
            >
              <CheckBox
                isChecked={isColSelected}
                cpName={name}
                isCompleteRowSelected={!isColSelected}
                onChange={() => selectCol(name, !isColSelected)}
                disabled={bulkMode ? true : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
              />
            </div>
          </div>
        ),
        accessor: acc,
      });
    }
    return cols;
  }
  function setTableColumns(headerNames) {
    const headers = columnsHtml(headerNames);
    setColumns(headers);
  }
  function scheduleOptions(imgScheduleOptions, selectedId) {
    if (imgScheduleOptions === null) {
      return null;
    }
    const arr = [];
    let selectedvalue = null;
    const filteredOptions = bulkMode
      ? imgScheduleOptions.filter(s => s.name !== 'Custom')
      : imgScheduleOptions;

    filteredOptions.map((schedulingValue) => {
      if (selectedId === schedulingValue.id) {
        selectedvalue = schedulingValue.id;
      }
      arr.push(
        <option
          data-testid={`imagingschedule-option-${schedulingValue.id}`}
          value={schedulingValue.id}
        >
          {schedulingValue.name}
        </option>,
      );
    });
    setSelectedValueOptions(selectedvalue);
    return arr;
  }
  function setDropDownOptions(imagingSchedules, selectedImagingScheduleId) {
    const options = scheduleOptions(imagingSchedules, selectedImagingScheduleId);
    setSchedulingOptionsHtml(options);
  }
  function getImagingScheduleOptions(imagingScheduleEntries, selectedSchedule) {
    const selectedEntries = [];
    for (let i = 0; i < imagingScheduleEntries.length; i++) {
      if (imagingScheduleEntries[i].id == selectedSchedule) {
        selectedEntries.push(imagingScheduleEntries[i]);
      }
    }
    const selectedEntriesWithUniqueRows = [];
    for (let i = 0; i < selectedEntries.length; i++) {
      const newEntry = {
        id: selectedEntries[i].id,
        cpName: selectedEntries[i].cpName,
        days: selectedEntries[i].days,
        hours: selectedEntries[i].hours,
        isSelected: selectedEntries[i].isSelected,
        entryId: selectedEntries[i].entryId,
      };
      selectedEntriesWithUniqueRows.push(newEntry);
    }
    return selectedEntriesWithUniqueRows;
  }
  async function fetchImagingData() {
    const imgSchedules = await fetchImagingSchedulesAsync(expId, dispatch);
    if (imgSchedules === null) {
      return;
    }
    const headerNames = imgSchedules.headers;
    const enteries = imgSchedules.imagingScheduleEntries;
    const data = getImagingScheduleOptions(
      imgSchedules.imagingScheduleEntries,
      imgSchedules.selectedImagingScheduleId,
    );
    if (data.length > 0) {
      selectedRow = {
        dayNum: data[0].days,
        hourNum: data[0].hours,
        entryId: data[0].entryId,
      };
    } else {
      selectedRow = { dayNum: '', hourNum: '', entryId: -1 };
    }
    setImagingScheduleDetails(
      imgSchedules.selectedImagingScheduleId,
      imgSchedules.imagingSchedules,
      imgSchedules.headers,
      enteries,
    );
    schedules = [...imgSchedules.imagingSchedules];
    imagingScheduleOptions = [...imgSchedules.imagingScheduleEntries];
    setData(optionsForScheduling(data, headerNames, imgSchedules.imagingScheduleEntries));
    headersContent = headerNames;
    selectedScheduleId = imgSchedules.selectedImagingScheduleId;
    // Set Columns for table
    setTableColumns(headerNames);
    // Set Options for Drop down
    setDropDownOptions(schedules, imgSchedules.selectedImagingScheduleId);
    setIsDirty(false);
  }
  function fetchImagingScheduleFromState() {
    const schedulingData = { ...exp.imagingSchedule };
    schedules = [...schedulingData.imagingSchedules];
    headersContent = schedulingData.headers;
    imagingScheduleOptions = [...schedulingData.imagingScheduleEntries];
    selectedScheduleId = schedulingData.selectedImagingScheduleId;
    setTableColumns(headersContent);
    const data = getImagingScheduleOptions(
      schedulingData.imagingScheduleEntries,
      schedulingData.selectedImagingScheduleId,
    );
    setData(
      optionsForScheduling(
        data,
        schedulingData.headers,
        schedulingData.imagingScheduleEntries,
      ),
    );
    setSchedulingOptionsHtml(
      scheduleOptions(
        schedulingData.imagingSchedules,
        schedulingData.selectedImagingScheduleId,
      ),
    );
  }
  async function fetchBulkModeImagingData() {
      const defaultSchedules = await imagingScheduleService.getImagingSchedules();

      if (defaultSchedules && defaultSchedules.length > 0 && experimentIds.length > 0) {
        const firstExpId = experimentIds[0];
        if (firstExpId) {
          const imgSchedules = await fetchImagingSchedulesAsync(firstExpId, null);
          if (imgSchedules) {
            const scheduleOptions = defaultSchedules.map((s) => ({
              id: s.id,
              name: s.name,
            }));

            schedules = scheduleOptions;
            headersContent = imgSchedules.headers;
            imagingScheduleOptions = [...imgSchedules.imagingScheduleEntries];
            selectedScheduleId = scheduleOptions[0]?.id || 0;

            const data = getImagingScheduleOptions(imagingScheduleOptions, selectedScheduleId);
            setData(optionsForScheduling(data, headersContent, imagingScheduleOptions));
            setTableColumns(headersContent);
            setDropDownOptions(scheduleOptions, selectedScheduleId);
          }
        }
      }
  }

  useEffect(() => {
    if (bulkMode) {
      fetchBulkModeImagingData();
    } else {
      if (isNullOrUndefined(exp.imagingSchedule)) {
        fetchImagingData();
      } else {
        fetchImagingScheduleFromState();
      }
    }
  }, [exp, bulkMode]);

  useEffect(() => {
    if (bulkMode && props.onSaveReady) {
      props.onSaveReady(onSaveBulkMode);
    }
  }, [bulkMode, experimentIds.length, selectedScheduleId]);

  useEffect(() => {
    if (_selectExpSaved && !bulkMode) {
      onSaveExp();
    }
  }, [_selectExpSaved, bulkMode]);

  async function onSaveBulkMode() {
    if ( !bulkMode || experimentIds.length === 0) {
      return;
    }

    const saveImagingScheduleDTO = {
      selectedImagingScheduleId: selectedScheduleId,
      imagingScheduleEntries: [],
      isChoosedCustom: false,
    };

    const bulkImagingSchedules = experimentIds.map((expId) => ({
      ExperimentId: expId,
      ImagingSchedule: saveImagingScheduleDTO,
    }));

    await experimentService.saveBulkImagingSchedule(bulkImagingSchedules);
    if (props.onClose) {
      props.onClose();
    }
  }

  async function onSaveExp() {
    if (bulkMode) {
      await onSaveBulkMode();
      return;
    }

    if (!getIsDirty()) {
      return;
    }
    setImagingScheduleDetails(selectedScheduleId, [...schedules], headersContent, [
      ...imagingScheduleOptions,
    ]);
    await fetchImagingData();
    selectedRow = { dayNum: '', hourNum: '', entryId: -1 };
    setIsDirty(false);
    props.setRefresh(true);
  }

  function onImagingScheduleChange(e) {
    const data = getImagingScheduleOptions(imagingScheduleOptions, e.target.value);
    const uniqueData = getUniqueSchedules(data).sort(function (x, y) {
      const n = x.days - y.days;
      if (n !== 0) {
        return n;
      }
      return x.hours - y.hours;
    });
    selectedRow =
      uniqueData.length > 0
        ? {
            dayNum: uniqueData[0].days,
            hourNum: uniqueData[0].hours,
            entryId: uniqueData[0].entryId,
          }
        : { dayNum: '', hourNum: '', entryId: -1 };

    if (!bulkMode) {
      dispatch(
        upsertImagingSchedule({
          imagingScheduleDetails: { selectedImagingScheduleId: parseInt(e.target.value) },
        }),
      );
    }

    selectedScheduleId = parseInt(e.target.value);
    setTableColumns(headersContent);
    setData(optionsForScheduling(data, headersContent, imagingScheduleOptions));
    setSchedulingOptionsHtml(scheduleOptions(schedules, e.target.value));
    setIsDirty(true);
    props.setRefresh(true);
  }

  function isCustomChoosen(id) {
    let customId = null;
    let isChoosedCustom = false;
    for (let i = 0; i < schedules.length; i++) {
      if (id === schedules[i].id && schedules[i].name === 'Custom') {
        isChoosedCustom = true;
      }
      if (schedules[i].name === 'Custom') {
        customId = schedules[i].id;
      }
    }
    return { customId, isChoosedCustom };
  }

  async function onChange(row, acc, imgScheduleOptions, cpName) {
    if (bulkMode) {
      return;
    }
    const { isChoosedCustom } = isCustomChoosen(row.id);
    let { customId } = isCustomChoosen(row.id);
    if (isChoosedCustom === false) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }
        imagingScheduleOptions = copySelectedScheduleToCustom(customId, row.id);
        const isEntryExist = imagingScheduleOptions.find(
          (e) =>
            e.cpName === cpName &&
            e.days === row.days &&
            e.hours === row.hours &&
            e.id === customId,
        );
        if (isEntryExist) {
          imagingScheduleOptions = imagingScheduleOptions.map((e) => {
            if (
              e.cpName === cpName &&
              e.days === row.days &&
              e.hours === row.hours &&
              e.id === customId
            ) {
              e.isSelected = false;
            }
            return e;
          });
        } else {
          const isEntryFind = imagingScheduleOptions.find(
            (e) => e.id === customId && e.days === row.days && e.hours === row.hours,
          );
          const entry = {
            days: row.days,
            hours: row.hours,
            cpName,
            id: customId,
            isSelected: true,
            entryId: -1,
          };
          if (isEntryFind) {
            entry.entryId = isEntryFind.entryId;
          }
          imagingScheduleOptions.push(entry);
        }
        const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
        selectedScheduleId = customId;
        setTableColumns(headersContent);
        setData(null);
        setData(optionsForScheduling(tableData, acc, imagingScheduleOptions));
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    } else {
      const entry = {
        days: row.days,
        hours: row.hours,
        cpName,
        id: customId,
        isSelected: true,
        entryId: row.entryId,
      };
      imagingScheduleOptions = updateEntry(entry, imgScheduleOptions);
      const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
      setTableColumns(headersContent);
      setData(optionsForScheduling(tableData, acc, imagingScheduleOptions));
      setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
    }
    dispatch(
      upsertImagingSchedule({
        imagingScheduleDetails: {
          selectedImagingScheduleId: selectedScheduleId,
          imagingSchedules: schedules,
          imagingScheduleEntries: imagingScheduleOptions,
        },
      }),
    );
    setIsDirty(true);
    props.setRefresh(true);
  }
  function updateEntry(entry, imgScheduleOptions) {
    const entries = [];
    let isFound = false;
    imgScheduleOptions.map((option) => {
      const entryOption = { ...option };
      if (
        entry.days === option.days &&
        entry.hours === option.hours &&
        entry.cpName === option.cpName &&
        entry.id === option.id &&
        option.isSelected &&
        option.entryId === entry.entryId
      ) {
        isFound = true;
        entryOption.isSelected = false;
        entries.push(entryOption);
      } else {
        entries.push(entryOption);
      }
    });
    if (!isFound) {
      entries.push(entry);
    }

    return entries;
  }

  const copySelectedScheduleToCustom = (customId, selectedScheduleId) => {
    const newOptions = [];
    imagingScheduleOptions.map((option) => {
      if (option.id == selectedScheduleId) {
        const entry = {
          days: option.days,
          hours: option.hours,
          cpName: option.cpName,
          id: customId,
          isSelected: true,
          entryId: -1 * option.entryId,
        };
        newOptions.push(option);
        newOptions.push(entry);
      } else if (option.id !== customId) {
        newOptions.push(option);
      }
    });
    return newOptions;
  };

  function getUniqueSchedules(schedules) {
    const uniqueSchedules = [];
    schedules.map((schedule) => {
      const alreadyExist = uniqueSchedules.find(
        (s) =>
          s.days === schedule.days &&
          s.hours === schedule.hours &&
          s.entryId === schedule.entryId,
      );
      if (!alreadyExist) {
        uniqueSchedules.push(schedule);
      }
    });
    return uniqueSchedules;
  }
  function isFindInEnteries(entry, cpName) {
    let isFind = false;
    for (let i = 0; i < imagingScheduleOptions.length; i++) {
      const curEntry = imagingScheduleOptions[i];
      if (
        curEntry.id == entry.id &&
        curEntry.days == entry.days &&
        curEntry.hours == entry.hours &&
        curEntry.cpName == cpName
      ) {
        isFind = true;
        break;
      }
    }
    return isFind;
  }

  async function selectCol(cpName, isCompleteRowSelected) {
    if (bulkMode) {
      return;
    }
    let { customId } = isCustomChoosen(selectedScheduleId);
    if (customId !== selectedScheduleId) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }

        imagingScheduleOptions = copySelectedScheduleToCustom(
          customId,
          selectedScheduleId,
        );
        selectedScheduleId = customId;
        setTableColumns(headersContent);
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    }
    //RFR-TODO: Update the imaging scheduling edit implementation
    imagingScheduleOptions = cloneDeep(imagingScheduleOptions);
    imagingScheduleOptions = imagingScheduleOptions.map((e) => {
      if (e.id === selectedScheduleId && e.cpName === cpName) {
        e.isSelected = isCompleteRowSelected;
      }
      return e;
    });
    const enteries = [...imagingScheduleOptions];
    for (let i = 0; i < imagingScheduleOptions.length; i++) {
      if (imagingScheduleOptions[i].id === selectedScheduleId) {
        const isFind = imagingScheduleOptions.find(
          (e) =>
            e.id === selectedScheduleId &&
            cpName === e.cpName &&
            e.days === imagingScheduleOptions[i].days &&
            e.hours === imagingScheduleOptions[i].hours &&
            e.entryId === imagingScheduleOptions[i].entryId,
        );
        if (!isFind) {
          const isEntryFind = imagingScheduleOptions.find(
            (e) =>
              e.id === selectedScheduleId &&
              e.days === imagingScheduleOptions[i].days &&
              e.hours === imagingScheduleOptions[i].hours &&
              e.entryId === imagingScheduleOptions[i].entryId,
          );
          const entry = {
            days: imagingScheduleOptions[i].days,
            hours: imagingScheduleOptions[i].hours,
            cpName,
            id: customId,
            isSelected: true,
            entryId: getNewId(),
          };
          if (isEntryFind) {
            entry.entryId = isEntryFind.entryId;
          }
          enteries.push(entry);
        }
      }
    }
    imagingScheduleOptions = [...enteries];
    dispatch(
      upsertImagingSchedule({
        imagingScheduleDetails: {
          selectedImagingScheduleId: selectedScheduleId,
          imagingSchedules: schedules,
          imagingScheduleEntries: imagingScheduleOptions,
        },
      }),
    );
    const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
    setTableColumns(headersContent);
    setData(optionsForScheduling(tableData, headersContent, imagingScheduleOptions));
    setIsDirty(true);
    props.setRefresh(true);
  }
  async function selectRow(row, isCompleteRowSelected) {
    let { customId } = isCustomChoosen(row.id);
    if (customId !== row.id && !bulkMode) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }
        imagingScheduleOptions = copySelectedScheduleToCustom(customId, row.id);
        selectedScheduleId = customId;
        setTableColumns(headersContent);
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    } else if (customId !== row.id && bulkMode) {
      customId = selectedScheduleId;
    }

    const entryId = customId == row.id ? row.entryId : row.entryId * -1;
    //RFR-TODO: Update the imaging scheduling edit implementation
    imagingScheduleOptions = cloneDeep(imagingScheduleOptions);
    imagingScheduleOptions = imagingScheduleOptions.map((e) => {
      if (
        e.id === row.id &&
        e.days === row.days &&
        e.hours === row.hours &&
        e.entryId === entryId
      ) {
        e.isSelected = isCompleteRowSelected;
      }
      return e;
    });
    for (let i = 0; i < headersContent.length; i++) {
      const isFind = imagingScheduleOptions.find(
        (e) =>
          e.id == customId &&
          e.days === row.days &&
          e.hours === row.hours &&
          e.cpName === headersContent[i] &&
          e.entryId === entryId,
      );
      if (!isFind) {
        const entryIndex = imagingScheduleOptions.findIndex(
          (e) =>
            e.id === customId &&
            e.days === row.days &&
            e.hours === row.hours &&
            e.entryId === entryId &&
            e.cpName == null,
        );
        if (entryIndex !== -1) {
          imagingScheduleOptions[entryIndex] = {
            ...imagingScheduleOptions[entryIndex],
            cpName: headersContent[i],
          };
        } else {
          const entry = {
            days: row.days,
            hours: row.hours,
            cpName: headersContent[i],
            id: customId,
            isSelected: true,
            entryId: entryId,
          };

          imagingScheduleOptions.push(entry);
        }
      }
    }
    if (!bulkMode) {
      dispatch(
        upsertImagingSchedule({
          imagingScheduleDetails: {
            selectedImagingScheduleId: selectedScheduleId,
            imagingSchedules: schedules,
            imagingScheduleEntries: imagingScheduleOptions,
          },
        }),
      );
    }
    const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
    setTableColumns(headersContent);
    setData(optionsForScheduling(tableData, headersContent, imagingScheduleOptions));
    setIsDirty(true);
    if (props.setRefresh) {
      props.setRefresh(true);
    }
  }
  async function onChangeScheduleDay({ rowData, value, id }) {
    if (parseInt(value) < 0 || Number.isNaN(value)) {
      value = 0;
    }
    let { customId } = isCustomChoosen(selectedScheduleId);
    if (customId !== selectedScheduleId) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }

        imagingScheduleOptions = copySelectedScheduleToCustom(customId, rowData.id);
        selectedScheduleId = customId;
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    }
    const enteries = [];
    //RFR-TODO: Update the imaging scheduling edit implementation
    imagingScheduleOptions = cloneDeep(imagingScheduleOptions);
    imagingScheduleOptions.map((entry) => {
      if (
        !(
          entry.id === selectedScheduleId &&
          entry.days === rowData.days &&
          entry.hours === rowData.hours &&
          entry.entryId === id
        )
      ) {
        enteries.push(entry);
      } else {
        entry.days = value;
        entry.id = selectedScheduleId;
        entry.entryId = rowData.entryId;
        enteries.push(entry);
      }
    });
    imagingScheduleOptions = enteries;
    const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
    dispatch(
      upsertImagingSchedule({
        imagingScheduleDetails: {
          selectedImagingScheduleId: selectedScheduleId,
          imagingSchedules: schedules,
          imagingScheduleEntries: imagingScheduleOptions,
        },
      }),
    );
    setData(optionsForScheduling(tableData, headersContent, imagingScheduleOptions));
    selectedRow = {
      dayNum: value,
      hourNum: rowData.hours,
      entryId: rowData.entryId,
    };
    setIsDirty(true);
    props.setRefresh(true);
  }
  async function onFocus(e) {
    let { customId } = isCustomChoosen(selectedScheduleId);
    if (customId !== selectedScheduleId) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }

        imagingScheduleOptions = copySelectedScheduleToCustom(
          customId,
          selectedScheduleId,
        );
        selectedScheduleId = customId;
        dispatch(
          upsertImagingSchedule({
            imagingScheduleDetails: {
              selectedImagingScheduleId: selectedScheduleId,
              imagingSchedules: schedules,
              imagingScheduleEntries: imagingScheduleOptions,
            },
          }),
        );
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
        setIsDirty(true);
        props.setRefresh(true);
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
  async function onChangeScheduleHour({ rowData, value, id }) {
    if (parseInt(value) < 0 || Number.isNaN(value)) {
      value = 0;
    }
    if (parseInt(value) > 23) {
      value = 23;
    }
    let { customId } = isCustomChoosen(selectedScheduleId);
    if (customId !== selectedScheduleId) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }

        imagingScheduleOptions = copySelectedScheduleToCustom(customId, rowData.id);
        selectedScheduleId = customId;
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    }
    const enteries = [];
    //RFR-TODO: Update the imaging scheduling edit implementation
    imagingScheduleOptions = cloneDeep(imagingScheduleOptions);
    imagingScheduleOptions.map((entry) => {
      if (
        !(
          entry.id === selectedScheduleId &&
          entry.days === rowData.days &&
          entry.hours === rowData.hours &&
          entry.entryId === id
        )
      ) {
        enteries.push(entry);
      } else {
        entry.hours = value;
        entry.id = selectedScheduleId;
        entry.entryId = rowData.entryId;
        enteries.push(entry);
      }
    });
    imagingScheduleOptions = enteries;
    const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
    selectedRow = {
      dayNum: rowData.days,
      hourNum: value,
      entryId: rowData.entryId,
    };
    if (!bulkMode) {
      dispatch(
        upsertImagingSchedule({
          imagingScheduleDetails: {
            selectedImagingScheduleId: selectedScheduleId,
            imagingSchedules: schedules,
            imagingScheduleEntries: imagingScheduleOptions,
          },
        }),
      );
    }
    setData(optionsForScheduling(tableData, headersContent, imagingScheduleOptions));
    setIsDirty(true);
    if(props.setRefresh) {
      props.setRefresh(true);
    }
  }
  function optionsForScheduling(tableData, names, imgScheduleOptions) {
    const htmlDataforTable = [];
    const uniqueData = getUniqueSchedules(tableData).sort(function (x, y) {
      const n = x.days - y.days;
      if (n !== 0) {
        return n;
      }
      return x.hours - y.hours;
    });
    for (let i = 0; i < uniqueData.length; i++) {
      const entry = {
        day: (
          <TextInput
            type="number"
            value={uniqueData[i].days}
            id={uniqueData[i].entryId}
            rowData={uniqueData[i]}
            onChange={onChangeScheduleDay}
            onFocus={onFocus}
            disabled={bulkMode ? true : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
          />
        ),
        hour: (
          <TextInput
            type="number"
            value={uniqueData[i].hours}
            id={uniqueData[i].entryId}
            rowData={uniqueData[i]}
            onChange={onChangeScheduleHour}
            onFocus={onFocus}
            disabled={bulkMode ? true : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
          />
        ),
        dayNum: uniqueData[i].days,
        hourNum: uniqueData[i].hours,
        entryId: uniqueData[i].entryId,
      };
      let isCompleteRowSelected = true;
      for (let j = 0; j < names.length; j++) {
        const name = names[j];
        let acc = '';
        name.split(' ').map((n) => (acc += n));

        const isfound = tableData.find(
          (s) =>
            s.days === uniqueData[i].days &&
            s.hours === uniqueData[i].hours &&
            names[j] === s.cpName &&
            s.entryId === uniqueData[i].entryId,
        );

        if (isfound) {
          const isChecked = isfound.isSelected;
          entry[acc] = (
            <CheckBox
              isChecked={isChecked}
              row={uniqueData[i]}
              acc={names}
              imgScheduleOptions={imgScheduleOptions}
              cpName={name}
              onChange={() => onChange(uniqueData[i], names, imgScheduleOptions, name)}
              disabled={bulkMode ? true : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
            />
          );
          if (!isChecked) {
            isCompleteRowSelected = false;
          }
        } else {
          entry[acc] = (
            <CheckBox
              isChecked={false}
              row={uniqueData[i]}
              acc={names}
              imgScheduleOptions={imgScheduleOptions}
              cpName={name}
              onChange={() => onChange(uniqueData[i], names, imgScheduleOptions, name)}
              disabled={bulkMode ? true : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
            />
          );
          isCompleteRowSelected = false;
        }
      }
      entry['maincheck'] = (
        <CheckBox
          isChecked={isCompleteRowSelected}
          onChange={() => selectRow(uniqueData[i], !isCompleteRowSelected)}
          row={uniqueData[i]}
          isCompleteRowSelected={!isCompleteRowSelected}
          disabled={bulkMode ? true : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
        />
      );
      htmlDataforTable.push(entry);
    }
    return htmlDataforTable;
  }

  async function removeSchedule(e) {
    if (bulkMode) {
      return;
    }
    if (!(exp.accessRightName === ETreeNodeAccessRightNames.Modify)) {
      return;
    }
    let { customId } = isCustomChoosen(selectedScheduleId);
    if (customId !== selectedScheduleId) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }

        imagingScheduleOptions = copySelectedScheduleToCustom(
          customId,
          selectedScheduleId,
        );
        selectedScheduleId = customId;
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    }
    const enteries = [];
    //RFR-TODO: Update the imaging scheduling edit implementation
    imagingScheduleOptions = cloneDeep(imagingScheduleOptions);
    imagingScheduleOptions.map((entry) => {
      if (
        !(
          entry.id === customId &&
          entry.days === selectedRow.dayNum &&
          entry.hours === selectedRow.hourNum &&
          entry.entryId === selectedRow.entryId
        )
      ) {
        enteries.push(entry);
      }
    });
    imagingScheduleOptions = enteries;
    const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
    if (tableData.length > 0) {
      selectedRow = {
        dayNum: tableData[0].days,
        hourNum: tableData[0].hours,
        entryId: tableData[0].entryId,
      };
    } else {
      selectedRow = { dayNum: '', hourNum: '', entryId: -1 };
    }
    dispatch(
      upsertImagingSchedule({
        imagingScheduleDetails: {
          selectedImagingScheduleId: selectedScheduleId,
          imagingSchedules: schedules,
          imagingScheduleEntries: imagingScheduleOptions,
        },
      }),
    );
    setData(optionsForScheduling(tableData, headersContent, imagingScheduleOptions));
    setIsDirty(true);
    props.setRefresh(true);
  }
  function getMax(arr, prop) {
    let max;
    for (let i = 0; i < arr.length; i++) {
      if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop])) {
        max = arr[i];
      }
    }
    return max;
  }
  async function addSchedule(e) {
    if (bulkMode) {
      return;
    }
    if (!(exp.accessRightName === ETreeNodeAccessRightNames.Modify)) {
      return;
    }
    let { customId } = isCustomChoosen(selectedScheduleId);
    if (customId !== selectedScheduleId) {
      if (await showModal(awaitableModalInfo.heading, awaitableModalInfo.body)) {
        if (customId === null) {
          schedules.push({ id: -1, name: 'Custom' });
          customId = -1;
        }

        imagingScheduleOptions = copySelectedScheduleToCustom(
          customId,
          selectedScheduleId,
        );
        selectedScheduleId = customId;
        setSchedulingOptionsHtml(scheduleOptions(schedules, customId));
      } else {
        return;
      }
    }
    const enteries = [...imagingScheduleOptions];
    const selectedEntries = enteries.filter((e) => e.id === selectedScheduleId);
    const newDay =
      selectedEntries.length === 0 ? 0 : getMax(selectedEntries, 'days').days + 1;
    const newEntryId = getNewId();
    enteries.push({
      days: newDay,
      hours: 0,
      entryId: newEntryId,
      id: selectedScheduleId,
    });
    imagingScheduleOptions = enteries;
    const tableData = getImagingScheduleOptions(imagingScheduleOptions, customId);
    dispatch(
      upsertImagingSchedule({
        imagingScheduleDetails: {
          selectedImagingScheduleId: selectedScheduleId,
          imagingSchedules: schedules,
          imagingScheduleEntries: enteries,
        },
      }),
    );
    selectedRow = { dayNum: newDay, hourNum: 0, entryId: newEntryId };
    setData(optionsForScheduling(tableData, headersContent, imagingScheduleOptions));
    setIsDirty(true);
    props.setRefresh(true);
  }
  function onRowClick(row) {
    selectedRow = row;
    props.setRefresh(true);
  }
  function Schedulingtable() {
    if (columns !== null) {
      return (
        <Table
          columns={columns}
          data={data}
          onRowClick={onRowClick}
          selectedRow={selectedRow}
        />
      );
    }
    return null;
  }
  return (
    <>
      {!bulkMode && (
        <div
          id="imagingschedule-container"
          data-testid="imagingschedule-container"
          style={styles.root}
        >
          Imaging Schedule
        </div>)}
      <div
        id="imagingschedule-row-header"
        data-testid="imagingschedule-row-header"
        className={`row mainHeadingMargin`}
      >
      {bulkMode && (
        <div
          id="imagingschedule-label-imagingscheduling"
          data-testid="imagingschedule-label-imagingscheduling"
          className="col-md-6 schedulngSubHeading"
        >
          Imaging Schedule
        </div>
      )}
        {!bulkMode && (
          <div
            id="imagingschedule-label-scheduling"
            data-testid="imagingschedule-label-scheduling"
            className="col-md-6 schedulngSubHeading"
          >
            Scheduling
          </div>
        )}
        <div
          id="imagingschedule-select-wrapper"
          data-testid="imagingschedule-select-wrapper"
          className="col-md-6 padding0"
        >
          <select
            data-testid="imagingschedule-select"
            className="select"
            value={selectedValueOptions}
            name="scheduling"
            id="imagingschedule-select"
            onChange={onImagingScheduleChange}
            disabled={bulkMode ? false : !(exp?.accessRightName === ETreeNodeAccessRightNames.Modify)}
          >
            {schedulingOptionsHtml}
          </select>
        </div>
      </div>
      <div
        id="imagingschedule-table-wrapper"
        data-testid="imagingschedule-table-wrapper"
        className={`schedulingTable ${bulkMode ? '!h-[50vh]' : ''}`}
      >
        {Schedulingtable()}
      </div>
      {!rmLite && !bulkMode ? (
        <div
          id="imagingschedule-bottommenu-wrapper"
          data-testid="imagingschedule-bottommenu-wrapper"
          className="bottomMenuParent"
        >
          <div
            id="imagingschedule-bottommenu-add"
            data-testid="imagingschedule-bottommenu-add"
            className="bottomMenu"
            onClick={addSchedule}
          >
            <AddIcon />
          </div>
          <div
            id="imagingschedule-bottommenu-remove"
            data-testid="imagingschedule-bottommenu-remove"
            className="bottomMenu"
            onClick={removeSchedule}
            style={{
              background: selectedRow.dayNum !== '' ? '#666666' : 'lightgray',
            }}
          >
            <RemoveIcon />
          </div>
        </div>
      ) : (
        ''
      )}
      {awaitableModalContent}
    </>
  );
}

const styles: IStyle = {
  root: {
    fontWeight: 700,
    fontFamily: 'Arial',
    color: '#F7A246',
    padding: '15px 10px',
    background: '#E4E4E4',
  },
};
